import * as helper from './../../../../../VX/View/Assets/Js/helper';
import Radiobox from './Radiobox';
import AlertBox from './AlertBox';

export default class Section3 {
	constructor() {
		let boxes = helper.$('#section3 .question-box-1');
		this.alertBox = new AlertBox(helper.$('#section3'));
		this.boxes = new Radiobox(boxes);
	}

	get values() {
		return {
			'preferences' : this.boxes.value
		};
	}

	isValid() {
		if (this.boxes.isValid()) {
			this.alertBox.hide();
			return true;
		}

		this.alertBox.show('Bitte wähle eine Vorliebe aus');
		return false;
	}
}
